import { useAtom } from "jotai";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { billAtom, getBillSubTotalAtom } from "../../helpers/state/bill";

export default function AddDiscountComponent() {
  const [bill, setBill] = useAtom(billAtom);
  const [subtotal] = useAtom(getBillSubTotalAtom);
  const [displayValue, setDisplayValue] = useState(0);

  // When the input changes
  const handleDiscountChange = (e) => {
    const value = parseFloat(e.target.value);
    let discount = isNaN(value) ? 0 : value;

    if (bill.discountType === "percent" && subtotal && !isNaN(value)) {
      discount = parseFloat(((value / 100) * subtotal).toFixed(2));
    }
    // If value mode, just use the value as is
    setBill({
      ...bill,
      discount,
    });
    setDisplayValue(e.target.value); // Always show what user typed
  };

  // When the type changes
  const handleTypeChange = (type) => {
    if (type === bill.discountType) return;
    let newDiscount = bill.discount || 0;
    let newDisplayValue = displayValue;

    if (subtotal) {
      if (type === "percent" && bill.discountType === "value") {
        // Convert value to percent for display
        newDisplayValue = subtotal
          ? ((newDiscount / subtotal) * 100).toFixed(2)
          : 0;
      } else if (type === "value" && bill.discountType === "percent") {
        // Convert percent to value
        newDisplayValue = newDiscount = parseFloat(
          ((newDiscount / subtotal) * 100).toFixed(2)
        );
        // But we want the value, so recalc:
        newDiscount = bill.discount;
      }
    }
    // If subtotal is 0, just set to 0
    if (!subtotal) {
      newDiscount = 0;
      newDisplayValue = 0;
    }
    // If switching to percent, update discount to percent value for display, but keep the atom as value
    setBill({
      ...bill,
      discountType: type,
      discount: type === "percent" ? bill.discount : newDiscount,
    });
    setDisplayValue(newDisplayValue);
  };

  // Display value in input according to display type
  const getDisplayValue = () => {
    const discount = bill.discount || 0;
    if (!subtotal) return discount;
    if (bill.discountType === "percent") {
      return subtotal ? ((discount / subtotal) * 100).toFixed(2) : 0;
    }
    return discount;
  };

  useEffect(() => {
    setDisplayValue(getDisplayValue());
    // eslint-disable-next-line
  }, [bill.discountType, bill.discount, subtotal]);

  return (
    <div className="field has-addons has-addons-centered">
      <p className="control">
        <div className="buttons has-addons">
          <button
            type="button"
            className={`button ${
              bill.discountType === "percent" ? "is-info" : ""
            }`}
            onClick={() => handleTypeChange("percent")}>
            %
          </button>
          <button
            type="button"
            className={`button ${
              bill.discountType === "value" ? "is-info" : ""
            }`}
            onClick={() => handleTypeChange("value")}>
            GHS
          </button>
        </div>
      </p>
      <p className="control is-expanded">
        <input
          className="input"
          type="number"
          step="0.01"
          autoFocus
          value={displayValue}
          placeholder={
            bill.discountType === "percent"
              ? "input discount % (e.g 20)"
              : "input discount value (e.g 50)"
          }
          onChange={handleDiscountChange}
        />
      </p>
    </div>
  );
}
